var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/clipboard-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.35 2H9.65001C8.61001 2 7.76001 2.84 7.76001 3.88V4.82C7.76001 5.86 8.60001 6.7 9.64001 6.7H14.35C15.39 6.7 16.23 5.86 16.23 4.82V3.88C16.24 2.84 15.39 2 14.35 2Z",
    fill: "#0061DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.24 4.82047C17.24 6.41047 15.94 7.71047 14.35 7.71047H9.65004C8.06004 7.71047 6.76004 6.41047 6.76004 4.82047C6.76004 4.26047 6.16004 3.91047 5.66004 4.17047C4.25004 4.92047 3.29004 6.41047 3.29004 8.12047V17.5305C3.29004 19.9905 5.30004 22.0005 7.76004 22.0005H16.24C18.7 22.0005 20.71 19.9905 20.71 17.5305V8.12047C20.71 6.41047 19.75 4.92047 18.34 4.17047C17.84 3.91047 17.24 4.26047 17.24 4.82047ZM12.38 16.9505H8.00004C7.59004 16.9505 7.25004 16.6105 7.25004 16.2005C7.25004 15.7905 7.59004 15.4505 8.00004 15.4505H12.38C12.79 15.4505 13.13 15.7905 13.13 16.2005C13.13 16.6105 12.79 16.9505 12.38 16.9505ZM15 12.9505H8.00004C7.59004 12.9505 7.25004 12.6105 7.25004 12.2005C7.25004 11.7905 7.59004 11.4505 8.00004 11.4505H15C15.41 11.4505 15.75 11.7905 15.75 12.2005C15.75 12.6105 15.41 12.9505 15 12.9505Z",
    fill: "#0061DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSelected);
export default __webpack_public_path__ + "static/media/TransactionSelected.89344ed19d40543365c713e2d4a01cec.svg";
export { ForwardRef as ReactComponent };